import {
  FaLock,
  FaUsers,
  FaTachometerAlt,
  FaComments,
  FaBox,
  FaChartLine,
  FaPlug,
  FaBullhorn,
  FaCalendarAlt,
  FaBuilding,
  FaCreditCard,
  FaKey,
} from 'react-icons/fa';

import {
  LuLayoutDashboard, LuMessageSquare, LuUsers, LuUserCog, LuPackage, LuLock,
  LuChartLine, LuPlug, LuMegaphone, LuCalendar, LuBuilding2, LuCreditCard,
  LuTarget, LuTrendingUp, LuContact, LuListChecks, LuBot, LuKey,
} from 'react-icons/lu';

export const PERMISSION_LABELS: Record<string, string> = {
  gbcode_admin_sistema: 'Administrador do Sistema',
  gestao_vendas: 'Gestão de Vendas - Admin',
  painel_operacional: 'Painel Operacional',
  agenda: 'Agenda',
  chat: 'Chat',
  fluxo_vendas: 'Fluxo de Vendas',
  contatos: 'Contatos',
  marketing_disparador: 'Marketing Disparador',
  marketing_templates: 'Marketing Templates',
  anuncios: 'Anúncios',
  relatorio_vendas: 'Relatórios Vendas',
  relatorio_campanhas: 'Relatório Campanhas',
  gestao_usuarios: 'Gestão de Usuários',
  gestao_equipes: 'Gestão de Equipes',
  gestao_metas: 'Gestão de Metas',
  regras_chatbot: 'Gestão de Regras',
  gestao_produtos: 'Gestão de Produtos',
  gestao_conexoes: 'Gestão de Conexões',
  dias_funcionamento: 'Dias de Funcionamento',
  gestao_empresas: 'Gestão de Empresas',
  gerenciar_planos: 'Gerenciar Planos',
  gestao_vendas_vendedor: 'Gestão de Vendas - Vendedor',
  gestao_campos_personalizados: 'Campos Personalizados',
  gestao_motivo_perda: 'Motivos de Perda',
  'conversas.todos': 'Ver conversas e negócios de todos',
  'contatos.gerenciar': 'Importar e excluir contatos',
  'marketing_disparador.gerenciar': 'Gerenciar campanhas',
  'marketing_templates.gerenciar': 'Gerenciar templates',
  'anuncios.gerenciar': 'Gerenciar contas de anúncio',
  gestao_tipos_usuario: 'Gestão de Tipos de Usuário',
};

export const getPermissionIcon = (name: string) => {
  const lowerName = name.toLowerCase();
  if (lowerName.includes('painel') || lowerName.includes('dashboard')) return <FaTachometerAlt />;
  if (lowerName.includes('chat') || lowerName.includes('conversa')) return <FaComments />;
  if (lowerName.includes('usuario') || lowerName.includes('user')) return <FaUsers />;
  if (lowerName.includes('produto') || lowerName.includes('product')) return <FaBox />;
  if (lowerName.includes('permiss') || lowerName.includes('acesso')) return <FaLock />;
  if (lowerName.includes('relatorio') || lowerName.includes('report') || lowerName.includes('analytics')) return <FaChartLine />;
  if (lowerName.includes('conex') || lowerName.includes('connection')) return <FaPlug />;
  if (lowerName.includes('campanha') || lowerName.includes('marketing')) return <FaBullhorn />;
  if (lowerName.includes('agenda') || lowerName.includes('calendario') || lowerName.includes('dia')) return <FaCalendarAlt />;
  if (lowerName.includes('empresa') || lowerName.includes('filial')) return <FaBuilding />;
  if (lowerName.includes('plano') || lowerName.includes('pagamento') || lowerName.includes('fatura')) return <FaCreditCard />;
  return <FaKey />;
};

/* ─────────────────────────────────────────────────────────────
   Versão Lucide, para as telas já migradas. A de cima (Font
   Awesome) fica enquanto houver tela no visual antigo usando.
   Ver docs/designsystem/padrao-de-tela.md §2.
   ───────────────────────────────────────────────────────────── */

export const getPermissionIconLu = (name: string) => {
  const n = name.toLowerCase();
  if (n.includes('painel') || n.includes('dashboard')) return <LuLayoutDashboard size={13} />;
  if (n.includes('chat') || n.includes('conversa')) return <LuMessageSquare size={13} />;
  if (n.includes('equipe')) return <LuUsers size={13} />;
  if (n.includes('usuario') || n.includes('user') || n.includes('perfil')) return <LuUserCog size={13} />;
  if (n.includes('produto')) return <LuPackage size={13} />;
  if (n.includes('permiss') || n.includes('acesso') || n.includes('admin')) return <LuLock size={13} />;
  if (n.includes('relatorio') || n.includes('report')) return <LuChartLine size={13} />;
  if (n.includes('conex')) return <LuPlug size={13} />;
  if (n.includes('campanha') || n.includes('marketing') || n.includes('disparador')) return <LuMegaphone size={13} />;
  if (n.includes('agenda') || n.includes('calendario') || n.includes('dias')) return <LuCalendar size={13} />;
  if (n.includes('empresa') || n.includes('filial')) return <LuBuilding2 size={13} />;
  if (n.includes('plano') || n.includes('pagamento') || n.includes('fatura')) return <LuCreditCard size={13} />;
  if (n.includes('meta')) return <LuTarget size={13} />;
  if (n.includes('venda') || n.includes('fluxo')) return <LuTrendingUp size={13} />;
  if (n.includes('contato')) return <LuContact size={13} />;
  if (n.includes('campo')) return <LuListChecks size={13} />;
  if (n.includes('regra') || n.includes('chatbot')) return <LuBot size={13} />;
  return <LuKey size={13} />;
};
